// import { Container as CommonContainer } from 'components';
import { PageContainer, SecondaryContainer as CommonContainer } from "components";
import { NoContent } from "components";
import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
import LabCard from './components/LabCard';
import { replaceIfNotExist } from "utils/newFunction";

function Labs({ data }) {
    const [listData, setListData] = useState<Array<any>>(() => data?.labs || []);

    useEffect(() => {
        setListData(data?.labs);
    }, [data?.labs]);

    const labs = useMemo(() => {
        const result = [];
        let clone = JSON.parse(JSON.stringify(listData));
        if (Array.isArray(clone)) {
            (function chunk() {
                result?.push?.(clone?.splice?.(0, 3));
                if (clone?.length > 0) return chunk();
            })();

            return result;
        }
        return []
    }, [listData]);

    const labsMobile = useMemo(() => {
        const result = [];
        let clone = JSON.parse(
            JSON.stringify(listData)
        );
        if (Array.isArray(clone)) {
            (function chunk() {
                result.push(clone?.splice?.(0, 2));
                if (clone?.length > 0) return chunk();
            })();

            return result;
        }
        return []
    }, [listData]);

    return (
        <PageContainer
            breadCrumb={data?.breadcrumb}
            seo={data?.seo}
            metaTag={replaceIfNotExist(data?.metaTag, { title: "آزمایشگاه ها" })}
            useDefaultHrefLang
        >
            <div className="tw-pb-[30px]">
                <CommonContainer>
                    <>
                        <div className="tw-hidden lg:tw-block tw-px-4 md:tw-px-0">
                            {labs?.length > 0 ? labs?.map?.((parent) => (
                                <div
                                    className={clsx(
                                        "tw-mb-[30px] last:tw-mb-0 tw-gap-[30px] tw-flex-wrap lg:tw-flex-nowrap",
                                        {
                                            "md:tw-inline-flex lg:tw-flex tw-justify-center": true,
                                            "tw-mx-auto md:tw-px-[30px]": parent?.length === 2,
                                        }
                                    )}
                                >
                                    {parent?.length > 0 ? parent?.map?.((v) => (
                                        <LabCard
                                            v={v}
                                            key={v?.id}
                                            size={parent?.length === 1 ? "large" : "small"}
                                            data={v}
                                        />
                                    )) : <NoContent />}
                                </div>
                            )) : <NoContent />}
                        </div>
                        <div className="tw-block lg:tw-hidden tw-px-4 md:tw-px-0">
                            {labsMobile?.length > 0 ? labsMobile?.map?.((parent) => (
                                <div
                                    className={clsx("tw-mb-[30px] last:tw-mb-0 tw-gap-[30px]", {
                                        "tw-flex tw-mx-auto lg:tw-px-[30px] tw-mx-auto":
                                            parent?.length < 2,
                                        "tw-grid tw-grid-cols-1 sm:tw-grid-cols-2":
                                            parent?.length === 2,
                                    })}
                                >
                                    {parent?.length > 0 ? parent?.map?.((v) => (
                                        <LabCard
                                            v={v}
                                            key={v?.id}
                                            single={parent?.length === 1}
                                            data={v}
                                        />
                                    )) : <NoContent />}
                                </div>
                            )) : <NoContent />}
                        </div>
                    </>
                </CommonContainer>
            </div>
        </PageContainer>
    );
}

export default Labs;
